import script from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./GenerateSnippetTagDialog.vue?vue&type=style&index=0&id=9d8e1646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d8e1646"]])

export default __exports__